import { MuiThemeProvider } from '@material-ui/core';
import { QueryClient, QueryClientProvider } from 'react-query';

import { BoletimProvider } from 'context/BoletimContext';
import { FarolStatusProvider } from 'context/FarolStatusContext';
import Routes from './routes';
import GlobalStyles from './styles/global';
import theme from './styles/theme';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <FarolStatusProvider>
          <BoletimProvider>
            <GlobalStyles />
            <Routes />
          </BoletimProvider>
        </FarolStatusProvider>
      </QueryClientProvider>
    </MuiThemeProvider>
  );
}

export default App;
